module.exports = __webpack_public_path__ + "img/banner-prouni-2022-1920x260-v2.29d5494f.png";